export default class DebtSendingSchedule {
  id = null;
  trigger = null;
  dayscount = 0;
  agenciesids = null;

  createdby = null;
  updatedby = null;
}
